import React from "react";
import { cn } from "@/lib/utils";

const TIER_STYLES = {
  platinum: "bg-[#64748B]/10 text-[#334155] border-[#64748B]/25",
  gold: "bg-[#EAB308]/12 text-[#854D0E] border-[#EAB308]/30",
  silver: "bg-[#9CA3AF]/12 text-[#475569] border-[#9CA3AF]/30",
  bronze: "bg-[#C58361]/15 text-[#8B4513] border-[#C58361]/35",
};

export default function TrustBadge({ tier = "bronze", score, size = "md", testid }) {
  const style = TIER_STYLES[tier] || TIER_STYLES.bronze;
  const sizeCls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span
      data-testid={testid || `trust-badge-${tier}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border font-semibold uppercase tracking-wider",
        style,
        sizeCls
      )}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      <span>{tier}</span>
      {score !== undefined && <span className="opacity-75">· {score}</span>}
    </span>
  );
}
